module.exports = __webpack_public_path__ + "img/drivers.c3e6e779.svg";